import { GraphQL } from '@guestgoodie/graphql'
import { useLingui } from '@lingui/react/macro'
import { useMemo } from 'react'

export function useStateToLabel() {
  const { t } = useLingui()

  return useMemo(() => {
    return {
      [GraphQL.StayStates.Scheduled]: t`Scheduled`,
      [GraphQL.StayStates.CheckedOut]: t`Checked Out`,
      [GraphQL.StayStates.Staying]: t`Checked In`
    }
  }, [t])
}

export function useStateOptions() {
  const stateToLabel = useStateToLabel()

  return useMemo(() => {
    return [
      {
        label: stateToLabel[GraphQL.StayStates.Scheduled],
        value: GraphQL.StayStates.Scheduled
      },
      {
        label: stateToLabel[GraphQL.StayStates.CheckedOut],
        value: GraphQL.StayStates.CheckedOut
      },
      {
        label: stateToLabel[GraphQL.StayStates.Staying],
        value: GraphQL.StayStates.Staying
      }
    ]
  }, [stateToLabel])
}
